import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config'
import {createRECManifest} from '../../../services/createRECManifest';

export default {
  name: 'InvScript',
  props: ['rootMethods'],
  components: {
    VueElementLoading
  },
  data() {
    return {
      shippingIDs: '',
      DataResponses: { data: {} },
      ResData:[]
    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    console.log("Date: ", moment(new Date()).format("DD-MM-YYYY HH:MM:SS"));
  },

  computed: {
    
  },

  methods: {
    Update(){
      let shipments = this.AWBRestrucure(this.shippingIDs);
      console.log("This is shipping IDs: ", shipments);
      let actionForInvestigationResult = ''; let RECManifestResult = '';
      shipments.map(shipment =>{
        try{
          this.getCallToActionForInvestigation(shipment).then(result => {
            console.log("Result: ",result);
            if (result.data.code == 200) {
              actionForInvestigationResult = result.data.message;
              setTimeout(()=>{
                  createRECManifest(shipment, this.myStr)
                  .then(result => {
                    if(result.data){
                      console.log("Created Manifest: ", result);
                      RECManifestResult = {RECShippingId:result.data.ShippingID ,message: result.data.ReturnMessage};
                      this.DataResponses = {
                        shippingID: shipment,
                        actionForInvestigation: actionForInvestigationResult,
                        RECManifest: RECManifestResult
                      }
                      this.ResData.push(this.DataResponses);
                    }
                  });
              }, 500);
            }else{
              this.DataResponses = {
                shippingID: shipment,
                actionForInvestigation: actionForInvestigationResult,
                RECManifest: RECManifestResult
              }
              this.ResData.push(this.DataResponses);
            }
          });
        }catch(Exception){
          console.log("Exception :: ",Exception );
        }
      });

    },
    AWBRestrucure(awbnumbers){
      let AWBStructure = awbnumbers
      AWBStructure=AWBStructure.replace(/[ ,]+/g, ",");
      AWBStructure=AWBStructure.replace(/\t/g,",");
      AWBStructure=AWBStructure.replace(/,\s*$/, "");
      AWBStructure = AWBStructure.replace(/,,/g, ",");
      AWBStructure = AWBStructure.replace(/\n/g, ",");
      AWBStructure = AWBStructure.split(',')
      return AWBStructure;
    },
    shipmentActionPayload(shippindId){
      let payload = {
        ActionStatusId: "20",
        Comments: "test",
        CurrentHubID: "212",
        IsManualInScan: "true",
        LastModifiedBy: "Automation",
        LastModifiedDate: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
        ShipmentVerifiedAs: "Physically",
        ShippingID: shippindId,
        StatusMarkedFrom: "web"
      }
      return payload;
    },
    getCallToActionForInvestigation(shippingID){
      console.log(this.shipmentActionPayload(shippingID));
      return axios({
        method: 'post',
        url: apiUrl.api_url + 'ActionforInvestigation',
        data: this.shipmentActionPayload(shippingID),
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/invScript/invScript.component.js